import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'admissions-accelerators-tab-2-part',
	standalone: true,
	templateUrl: './admissions-accelerators-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-accelerators-tab-2.part.scss`],
})
export class AdmissionsAcceleratorsTab2Part {
}
